import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import "./content.css";

const UserGuidelines = () => {
  return (
    <div className="terms content_page">
      <Breadcrumb name={"Terms & Conditions"} pageName={"Terms & Conditions"} />
      <div className="terms-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="terms-info-wraps">
                <h4 className="title">
                User Guidelines
                </h4>
                <p>At Classhila, we are dedicated to fostering a positive learning and teaching environment where
users can interact freely, sharing knowledge and ideas. To ensure that all users have the best
possible experience, we ask that you follow the guidelines below.</p>
<p>Given the interactive nature of our platform, it is crucial to prevent misuse that could hinder
anyone’s experience. If you encounter inappropriate content, you have the option to report or
flag it. However, please use this feature responsibly. Before reporting, review the guidelines to
ensure your concerns align with our policies.</p>
<p>These guidelines should be read in conjunction with our Terms and Conditions, Privacy Policy,
and other relevant policies on the Classhila platform.</p>

<h5>1. Prohibited Acts and Content</h5>

<ul className=" mt-4 inline_b dot_list"><li><b>Harmful or Dangerous Content: </b><p>Classhila is a safe space for learners and educators.
Content that incites or promotes violence, causes harm, or endangers anyone’s safety is
strictly prohibited. Educational references to harmful acts are allowed, but the sale or
promotion of illegal or regulated goods is not. The platform is strictly for permitted uses
as outlined in our Terms and Conditions.</p></li>
<li><b>Violent and Graphic Content:</b><p> As an educational platform, content must be limited to
educational purposes. Violent or graphic content is prohibited unless referenced for
educational reasons. Content intended to sensationalize, shock, or disturb users is not
allowed, nor is content that promotes terrorism or incites violence.</p></li>
<li><b>Hateful Content:</b><p> While the exchange of ideas is vital to learning, hate speech is not
tolerated. Hate speech includes content that incites hatred toward individuals or groups
based on race, ethnicity, nationality, caste, religion, disability, gender, age, sexual
orientation, or gender identity.</p></li>
<li><b>Scams:</b><p> Any content intended to deceive others for financial gain, including extortion or
blackmail, is strictly forbidden.</p></li>
<li><b>Harassment and Bullying: </b><p>Classhila values respect and kindness. Harassment,
including abusive videos, comments, or messages, revealing personal information, or
sexual harassment in any form, will not be tolerated.</p></li>
<li><b>Spam: </b><p>Posting repetitive, unwanted content in lessons, comments, or messages to drive
traffic to third-party sites is prohibited. Links to malware or harmful sites are not allowed,
nor is using automated systems to send excessive requests to Classhila’s servers.</p></li>
<li><b>Misleading Metadata:</b><p> Misusing titles, descriptions, tags, thumbnails, or other metadata
to deceive users or circumvent our algorithms is prohibited.</p></li>
<li><b>Copyright Infringement: </b><p>Please refer to our copyright policy within the Terms and
Conditions for details on proprietary information regarding user content and Classhila
content.</p></li>
<li><b>Privacy Violations: </b><p>Respect the privacy of others by adhering to our Privacy Policy. If
you believe your privacy has been violated, contact the user directly if possible, or reach
out to us for assistance.</p></li>
<li><b>Impersonation: </b><p>Pretending to be someone else or misrepresenting yourself as an entity
or group is prohibited. Impersonation may involve using someone else’s name, image,
documents, or logos, potentially infringing on trademarks.</p></li>
<li><b>Interaction with Classhila: </b><p>We value respectful communication with our users. Any
abusive, hateful, or inappropriate interactions with Classhila staff are strictly prohibited.</p></li>




</ul>
<h4>2. Reporting Tools</h4>
<p>Classhila provides built-in reporting tools to flag content that violates these guidelines, infringes
intellectual property, or is deemed spam. You can report videos and comments, but please
ensure the content violates the guidelines before reporting to avoid false claims. For additional
assistance, contact us at  <a href="mailto:help.classhila@gmail.com">  support@classhila.com.</a></p>

<h5>Tips for Safe Platform Use</h5>
<h4>A. Keeping Your Account Safe</h4>
<ul className=" mt-4 dot_list">
    <li>Keep your login credentials confidential and use a strong password (at least eight
characters, combining numbers, special characters, and a mix of upper and lowercase
letters).</li>
    <li>Don&#39;t reuse passwords associated with any other type of account.</li>
    <li>Log out of devices after each session and ensure backup through phone registration.</li>
    <li>Do not share personal information online or meet individuals from online interactions in
    person for safety reasons.</li>
    <li>Users under 18 must have a parent or guardian create an account on their behalf.</li>
</ul>
<h4>B. Reporting Content</h4>
<ul className=" mt-4 dot_list">
    <li>Report content that could confuse users about its origin or falsely imply endorsement, as
    this may infringe on trademarks.</li>
    <li>Trademark or copyright owners may report violations, but Classhila does not mediate
disputes. Genuine infringement claims may result in content removal and a warning to
the offender.</li>
    <li>If you believe your privacy or another’s has been violated, report the content for review.
Content will be removed if it clearly identifies sensitive personal information, images,
etc..</li>
    <li>Report any harassment or bullying on the platform. For further assistance, contact
    help@classhila.com.</li>
   
</ul>
<h4>C. Posting Content</h4>

<ul className=" mt-4 dot_list">
    <li>Ensure the accuracy of your posts and that content does not infringe on third-party rights
    or violate our prohibited content guidelines.</li>
    <li>Avoid sharing personal or identifiable information, as it violates our Privacy Policy.</li>
    <li>You are responsible for your actions on the platform, so ensure that your content does
    not offend the sentiments of any group/individual or harm/bully others.</li>
    
</ul>
 </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserGuidelines;
